export default "__VITE_ASSET__7ec6dcd6__"